<template>
  <div class="check-wrapper">
    <van-notice-bar v-if="disabled" left-icon="volume-o" :text="notice" />

    <div class="scan-wapper">
      <van-icon name="scan" class="scan" color="#888" size="120" />

      <van-button
        type="info"
        block
        :disabled="disabled"
        :loading="loading"
        @click.native="handleScan"
      >
        扫描二维码
      </van-button>
    </div>
  </div>
</template>
<script>
import { createCheck, getLogin } from '@/api/api-venue';
import { handelWeChatConfig, handelWeChatScanQRCode } from '@/utils/util';

export default {
  data() {
    return {
      disabled: false,
      loading: false,
      notice: '',
    };
  },
  created() {
    this.checkParams();
    this.handleInit();
  },
  methods: {
    checkParams() {
      const {
        query: { spot_id: spotId },
        path,
      } = this.$route;
      if (spotId) {
        this.$router.replace(path);
      }
    },
    async handleInit() {
      const data = await getLogin();
      if (data) {
        handelWeChatConfig();
      } else {
        this.disabled = true;
      }
    },
    handleScan() {
      this.disabled = true;
      this.loading = true;
      handelWeChatScanQRCode().then(res => {
        this.handleScanSuccess(res);
      });
    },
    handleScanCancel() {
      this.disabled = false;
      this.loading = false;
    },
    async handleScanSuccess(res) {
      const { errMsg, resultStr: code } = res;
      if (errMsg === 'scanQRCode:ok') {
        const data = await createCheck({ code });
        if (data) {
          this.$router.push({
            name: 'venue_ticket_check',
            query: { type: 'success', text: `${data.ticket} - ${data.shape}` },
          });
        } else {
          this.$router.push({
            name: 'venue_ticket_check_result',
            query: { type: 'failed' },
          });
        }
      }
      this.disabled = false;
      this.loading = false;
    },
  },
};
</script>
<style lang="less" scoped>
.check-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  .van-notice-bar {
    position: fixed;
    top: 0;
    width: 100%;
  }
  .scan-wapper {
    padding: 60px 16px;
  }
  .van-button {
    margin-top: 40px;
    border-radius: 6px;
  }
}
</style>
